import { TeamReview } from "./TeamReview";
import { TeamReviewDecision } from "./TeamReviewDecision";

export class UserSubmission {
    userSubmissionId: string = "";
    teamReview: TeamReview | null = null;
    status: TeamReviewDecision = TeamReviewDecision.NotYetStarted;
    dateSubmitted: Date = new Date(0);
    dateCompleted: Date = new Date(0);
    type: string = "UserSubmission";
    nodeId: string = "";
}